/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetEvidences200ResponseInnerCreatedBy } from './get-evidences200-response-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidences200ResponseInnerErrors } from './get-evidences200-response-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidences200ResponseInnerInvoiceIssuer } from './get-evidences200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidences200ResponseInnerUpdatedBy } from './get-evidences200-response-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidences200ResponseInnerUploadedBy } from './get-evidences200-response-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetEvidences200ResponseInnerWarnings } from './get-evidences200-response-inner-warnings';

/**
 * 
 * @export
 * @interface GetEvidences200ResponseInner
 */
export interface GetEvidences200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'paymentType': GetEvidences200ResponseInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'electronicMethod': GetEvidences200ResponseInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'documentSize': GetEvidences200ResponseInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEvidences200ResponseInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'legalValidity': GetEvidences200ResponseInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetEvidences200ResponseInnerInvoiceIssuer}
     * @memberof GetEvidences200ResponseInner
     */
    'invoiceIssuer': GetEvidences200ResponseInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'dpiError': GetEvidences200ResponseInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'detectedDpiError': GetEvidences200ResponseInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'calculatedDpiError': GetEvidences200ResponseInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'colorGradationError': GetEvidences200ResponseInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'heightMillisError': GetEvidences200ResponseInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     * @deprecated
     */
    'widthMillisError': GetEvidences200ResponseInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetEvidences200ResponseInnerErrors}
     * @memberof GetEvidences200ResponseInner
     */
    'errors': GetEvidences200ResponseInnerErrors;
    /**
     * 
     * @type {GetEvidences200ResponseInnerWarnings}
     * @memberof GetEvidences200ResponseInner
     */
    'warnings': GetEvidences200ResponseInnerWarnings;
    /**
     * 
     * @type {GetEvidences200ResponseInnerCreatedBy}
     * @memberof GetEvidences200ResponseInner
     */
    'createdBy': GetEvidences200ResponseInnerCreatedBy;
    /**
     * 
     * @type {GetEvidences200ResponseInnerUpdatedBy}
     * @memberof GetEvidences200ResponseInner
     */
    'updatedBy': GetEvidences200ResponseInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetEvidences200ResponseInnerUploadedBy}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedBy': GetEvidences200ResponseInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetEvidences200ResponseInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetEvidences200ResponseInner
     */
    'uploadedFrom': string;
}

export const GetEvidences200ResponseInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetEvidences200ResponseInnerPaymentTypeEnum = typeof GetEvidences200ResponseInnerPaymentTypeEnum[keyof typeof GetEvidences200ResponseInnerPaymentTypeEnum];
export const GetEvidences200ResponseInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerElectronicMethodEnum = typeof GetEvidences200ResponseInnerElectronicMethodEnum[keyof typeof GetEvidences200ResponseInnerElectronicMethodEnum];
export const GetEvidences200ResponseInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerDocumentSizeEnum = typeof GetEvidences200ResponseInnerDocumentSizeEnum[keyof typeof GetEvidences200ResponseInnerDocumentSizeEnum];
export const GetEvidences200ResponseInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetEvidences200ResponseInnerLegalValidityEnum = typeof GetEvidences200ResponseInnerLegalValidityEnum[keyof typeof GetEvidences200ResponseInnerLegalValidityEnum];
export const GetEvidences200ResponseInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerDpiErrorEnum = typeof GetEvidences200ResponseInnerDpiErrorEnum[keyof typeof GetEvidences200ResponseInnerDpiErrorEnum];
export const GetEvidences200ResponseInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerDetectedDpiErrorEnum = typeof GetEvidences200ResponseInnerDetectedDpiErrorEnum[keyof typeof GetEvidences200ResponseInnerDetectedDpiErrorEnum];
export const GetEvidences200ResponseInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetEvidences200ResponseInnerCalculatedDpiErrorEnum = typeof GetEvidences200ResponseInnerCalculatedDpiErrorEnum[keyof typeof GetEvidences200ResponseInnerCalculatedDpiErrorEnum];
export const GetEvidences200ResponseInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetEvidences200ResponseInnerColorGradationErrorEnum = typeof GetEvidences200ResponseInnerColorGradationErrorEnum[keyof typeof GetEvidences200ResponseInnerColorGradationErrorEnum];
export const GetEvidences200ResponseInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerHeightMillisErrorEnum = typeof GetEvidences200ResponseInnerHeightMillisErrorEnum[keyof typeof GetEvidences200ResponseInnerHeightMillisErrorEnum];
export const GetEvidences200ResponseInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetEvidences200ResponseInnerWidthMillisErrorEnum = typeof GetEvidences200ResponseInnerWidthMillisErrorEnum[keyof typeof GetEvidences200ResponseInnerWidthMillisErrorEnum];


